import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../pipes/pipes.module';
import { PurchasePromotionPageRoutingModule } from './purchase-promotion-routing.module';
import { PurchasePromotionPage } from './purchase-promotion.page';
import { ExpandableComponent } from '../components/expandable/expandable.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule,
    PurchasePromotionPageRoutingModule
  ],
  declarations: [PurchasePromotionPage, ExpandableComponent],
  exports: [ExpandableComponent]
})
export class PurchasePromotionPageModule {
}
